var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHousiGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_44",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0024 3.00061H33.003V33.0012H3.0024V3.00061Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_44)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.13 28.4977C21.7739 29.9919 20.2113 31.2847 18.4896 32.3371C18.3826 32.4172 18.2536 32.4625 18.1201 32.467C17.9865 32.4715 17.8547 32.435 17.7426 32.3623C15.2871 30.8134 13.1063 28.8668 11.2896 26.6023C8.937 23.6521 7.4556 20.3833 6.9516 17.2315C6.4332 14.0383 6.9156 10.9639 8.5068 8.46547C9.15297 7.44972 9.96458 6.54929 10.908 5.80147C13.1508 4.01767 15.7122 3.07267 18.2646 3.09247C20.7216 3.11047 23.148 4.02667 25.245 5.94187C25.9812 6.61147 26.6004 7.37827 27.1062 8.20987C28.8162 11.0269 29.1852 14.6179 28.4346 18.2539C27.693 21.8503 25.8516 25.5025 23.13 28.4923V28.4977ZM17.7768 8.77147C18.4973 8.77147 19.2107 8.91338 19.8764 9.1891C20.542 9.46481 21.1468 9.86894 21.6563 10.3784C22.1657 10.8879 22.5699 11.4927 22.8456 12.1583C23.1213 12.824 23.2632 13.5374 23.2632 14.2579C23.2632 14.9784 23.1213 15.6918 22.8456 16.3574C22.5699 17.0231 22.1657 17.6279 21.6563 18.1373C21.1468 18.6468 20.542 19.0509 19.8764 19.3266C19.2107 19.6024 18.4973 19.7443 17.7768 19.7443C16.3217 19.7443 14.9262 19.1662 13.8973 18.1373C12.8684 17.1084 12.2904 15.713 12.2904 14.2579C12.2904 12.8028 12.8684 11.4073 13.8973 10.3784C14.9262 9.3495 16.3217 8.77147 17.7768 8.77147Z",
    fill: "#FBFDFD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousiGrayIcon);
export default __webpack_public_path__ + "static/media/housi-gray-icon.3c933a8b1cb1386f9d8a6ec0153fe3a2.svg";
export { ForwardRef as ReactComponent };